import { differenceInDays, differenceInYears, subYears } from "date-fns";

import getAgeRequirementForState from "./getAgeRequirementsForState";

// An FYI for using the Date constructor: the month parameter (2nd position) is 0-based,
// so January is 0, February is 1, etc. The day parameter (3rd position) is 1-based,
// so the first day of the month is 1.

type YearsArrayCreationProps = {
  countryCode: string;
  selectedDay?: number;
  selectedMonth?: number;
  state?: string;
};

export const createYearsArrayForAgeLimit = ({
  countryCode,
  selectedDay = 1,
  selectedMonth = 0,
  state,
}: YearsArrayCreationProps): number[] => {
  const currentDate = new Date();
  const currentYear = currentDate.getUTCFullYear();

  const minAgeRequirement = getAgeRequirementForState(countryCode, state);

  const selectedDateYearsAgo = subYears(
    new Date(
      currentYear,
      selectedMonth === 0 ? selectedMonth : selectedMonth - 1,
      selectedDay || 1,
    ),
    minAgeRequirement,
  );

  //compare dates
  const isValidDob =
    differenceInYears(currentDate, selectedDateYearsAgo) >= minAgeRequirement;

  //if date is not valid decrement year to account for partial year.
  const displayedYearEnd = isValidDob
    ? currentYear - minAgeRequirement
    : currentYear - minAgeRequirement - 1;

  const yearRange: number[] = [];
  for (let i = displayedYearEnd; i > 1900; i--) {
    yearRange.push(i);
  }

  return yearRange;
};

export const createYearsArrayForMedCardExpiration = ({
  selectedDay = 1,
  selectedMonth = 0,
}: Pick<YearsArrayCreationProps, "selectedDay" | "selectedMonth">) => {
  const currentDate = new Date();
  const currentYear = currentDate.getUTCFullYear();

  const selectedDateToday = new Date(
    currentYear,
    selectedMonth === 0 ? selectedMonth : selectedMonth - 1,
    selectedDay || 1,
  );

  const isValid = differenceInDays(currentDate, selectedDateToday) <= 0;

  //if date is not valid decrement year to account for partial year.
  const displayedYearStart = isValid ? currentYear : currentYear + 1;

  const yearRange: number[] = [];
  for (let i = displayedYearStart; i < displayedYearStart + 50; i++) {
    yearRange.push(i);
  }

  return yearRange;
};

export const createDefaultYearsArray = () => {
  const currentYear = new Date().getFullYear();

  return Array.from({ length: currentYear - 1900 }, (_, i) => currentYear - i);
};
